export default {"src":"/_next/static/media/features-remove-email-trackers.137b2d3b.svg","height":403,"width":474,"blurWidth":0,"blurHeight":0};